document.addEventListener("DOMContentLoaded", () => {
  // Add event listener to buttons with the "data-wf-logout" attribute
  const logoutButtons = document.querySelectorAll("[data-wf-logout]");

  logoutButtons.forEach(button => {
    button.addEventListener("click", async e => {
      e.preventDefault();

      try {
        // Clear server-side
        await fetch("/logout", { method: "POST", credentials: "include" });

        //Alerts use local and session storage (and should be persisted between logouts), so we should not blindly clear those, even on logout.

        const redirectUrl = (button as HTMLElement).getAttribute("data-wf-logout");
        window.location.href = redirectUrl?.trim() ? redirectUrl : "/";
      } catch (err) {
        console.error("Logout failed", err);
        window.location.reload(); // fallback
      }
    });
  });
});
